/*
 * Copyright (c) 2025. Bolmate B.V.
 */

import {ChangeFunction} from '@dvrd/dvr-controls';

import React from 'react';
import {useTranslation} from 'react-i18next';

import NotificationInputController from './notificationInput/notificationInputController';

interface Props {
    onChangeEmailAddresses: ChangeFunction<string>;
    emailAddresses: Array<string>;
    disabled: boolean;
}

export default function NotificationEmail(props: Props) {
    const {t} = useTranslation();
    const {onChangeEmailAddresses, emailAddresses, disabled} = props;
    return (
        <section>
            <label className='fixed-text'>
                {t('notifications.components.sendNotificationTo', 'stuur een notificatie naar')}
            </label>
            <NotificationInputController
                onSubmit={onChangeEmailAddresses}
                value={emailAddresses.join(',')}
                label={t('notifications.components.sendNotificationToLabel', 'Stuur notificatie naar')}
                inputProps={{inputProps: {type: 'email', multiple: true}}}
                disabled={disabled}
            />
        </section>
    );
}
